module.exports = __webpack_public_path__ + "img/pic_category_02_w768.587b0150.png";